import { render, staticRenderFns } from "./AdminRequestsListView.vue?vue&type=template&id=b601ebda&scoped=true"
import script from "./AdminRequestsListView.vue?vue&type=script&lang=js"
export * from "./AdminRequestsListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b601ebda",
  null
  
)

export default component.exports